// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class^=cello-],[class*=" cello-"]{transform:scale(0.7) !important}`, "",{"version":3,"sources":["webpack://./react/containers/CelloLauncher/CelloLauncher.scss"],"names":[],"mappings":"AAAA,mCAAmC,+BAA+B","sourcesContent":["[class^=cello-],[class*=\" cello-\"]{transform:scale(0.7) !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
